import "./style.css";
import { initRum } from "./lib/rum";

// Datadog RUM. No-ops in dev (no PUBLIC_DD_* env); initializes in test/prod.
initRum();

// Sticky-header shadow once the page scrolls past the hero top.
const header = document.querySelector(".site-header");
if (header) {
  const onScroll = () => header.classList.toggle("scrolled", window.scrollY > 8);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
}

// Scroll-reveal for sections — progressive enhancement; content is visible if JS
// or IntersectionObserver is unavailable (see the reveal fallback in CSS).
const revealables = document.querySelectorAll<HTMLElement>(".reveal");
if ("IntersectionObserver" in window && revealables.length) {
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          io.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
  );
  for (const el of revealables) io.observe(el);
} else {
  for (const el of revealables) el.classList.add("in");
}
